"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_virtualized_1 = require("react-virtualized");
var styles_1 = require("@material-ui/core/styles");
var classnames_1 = __importDefault(require("classnames"));
require("react-virtualized/styles.css");
var constants_1 = require("../../constants");
var DataGridHeader_1 = __importDefault(require("../../DataGridHeader"));
var DataGridCell_1 = require("../../DataGridCell");
var hooks_1 = require("../hooks");
var columns_1 = require("../../context/columns");
var props_1 = require("../../context/props");
var DataGridRowRenderer_1 = require("../../DataGridRowRenderer");
var useStyles = (0, styles_1.makeStyles)(function (_a) {
    var typography = _a.typography, palette = _a.palette;
    return ({
        root: __assign(__assign({}, typography.body2), { fontSize: typography.caption.fontSize, '&:focus': {
                outline: 'none'
            } }),
        row: {
            borderBottom: "1px solid ".concat(palette.divider)
        },
        header: {
            textTransform: 'none'
        }
    });
});
var AutoSizer = react_virtualized_1.AutoSizer;
var Table = react_virtualized_1.Table;
var Column = react_virtualized_1.Column;
var DataGridDesktopBody = function (props) {
    var data = props.data, onLastRow = props.onLastRow, rowHeight = props.rowHeight, headerHeight = props.headerHeight, isDynamicRowHeight = props.isDynamicRowHeight, _a = props.onRowsRendered, onRowsRendered = _a === void 0 ? function () { } : _a, _b = props.registerChild, registerChild = _b === void 0 ? function () { } : _b, rowRenderer = props.rowRenderer, cellProps = props.cellProps;
    var tableRef = props.tableRef;
    var itemsCount = data.length;
    /* eslint-disable */
    var setRef = (0, react_1.useCallback)(function (ref) {
        tableRef = ref;
        registerChild(ref);
    }, []);
    /* eslint-enable */
    // When the data is updated scroll the table up
    (0, react_1.useEffect)(function () {
        if (tableRef.current)
            tableRef.current.scrollToIndex = 0;
        // eslint-disable-next-line
    }, [data]);
    var columnsState = (0, columns_1.useColumnsContext)().columnsState;
    var _c = (0, props_1.usePropsContext)(), isFlexibleColumns = _c.isFlexibleColumns, classes = _c.classes;
    var _d = (0, hooks_1.useStateColumnsWidth)(columnsState), stateColumnsWidth = _d.stateColumnsWidth, handlerColumnWidth = _d.handlerColumnWidth;
    var innerClasses = useStyles();
    var rowGetter = (0, hooks_1.useRowGetter)(data, itemsCount, onLastRow).rowGetter;
    var cellMeasurerCache = (0, hooks_1.useCellMeasurerCache)(rowHeight);
    var desktopRowRenderer = (0, react_1.useMemo)(function () { return (0, DataGridRowRenderer_1.dataGridDesktopRowRenderer)(rowRenderer); }, [rowRenderer]);
    var tableRowHeight = (0, hooks_1.useRowHeight)(isDynamicRowHeight, cellMeasurerCache, rowHeight);
    return (react_1.default.createElement("div", { style: { height: '100%' } },
        react_1.default.createElement(AutoSizer, null, function (_a) {
            var _b;
            var _c, _d;
            var width = _a.width, height = _a.height;
            return (react_1.default.createElement(Table, { width: width, height: height, rowCount: itemsCount, rowGetter: rowGetter, rowHeight: tableRowHeight, headerHeight: headerHeight || constants_1.HEADER_HEIGHT, className: innerClasses.root, rowClassName: innerClasses.row, headerClassName: (0, classnames_1.default)((_b = {},
                    _b[innerClasses.header] = true,
                    _b[((_c = classes === null || classes === void 0 ? void 0 : classes.header) === null || _c === void 0 ? void 0 : _c.root) || ''] = !!((_d = classes === null || classes === void 0 ? void 0 : classes.header) === null || _d === void 0 ? void 0 : _d.root),
                    _b)), onRowsRendered: onRowsRendered, ref: setRef, deferredMeasurementCache: cellMeasurerCache, rowRenderer: desktopRowRenderer, noRowsRenderer: function () { return react_1.default.createElement("div", null); } }, columnsState.map(function (column, columnIndex) { return (column.visible ? (react_1.default.createElement(Column, { id: column.id, key: column.id, label: column.label, dataKey: column.id, headerRenderer: function (headerRendererProps) { return (react_1.default.createElement(DataGridHeader_1.default, __assign({}, headerRendererProps, { column: column, handlerColumnWidth: handlerColumnWidth, width: width, columnIndex: columnIndex }))); }, cellRenderer: function (cellRendererProps) { return (react_1.default.createElement(DataGridCell_1.DataGridDesktopCell, __assign({}, cellRendererProps, { cache: cellMeasurerCache, isDynamicRowHeight: isDynamicRowHeight, columnIndex: columnIndex, column: column, cellProps: cellProps }))); }, width: isFlexibleColumns
                    ? stateColumnsWidth[column.id] * width
                    : column.width || constants_1.DEFAULT_COLUMN_WIDTH, flexGrow: !column.width && !isFlexibleColumns ? 1 : undefined })) : null); })));
        })));
};
exports.default = DataGridDesktopBody;
